import i18n from "../../../utilities/i18n";

/**
 * Single data manager handling both Pre-Billing and Post-Billing (AR) workflows.
 * 
 * @param {Object} item - Existing workflow item object.
 * @param {Array} data - Existing list of workflow items for indexing/sequence calculations.
 * @param {'new' | 'edit'} actionType - Type of action performed.
 * @param {'pre_billing' | 'post_billing'} workflowType - Workflow classification type.
 */
export const workflowDataManager = (item, data = [], actionType = 'new', workflowType = 'pre_billing') => {
    if (actionType === 'edit' && !item) return null;

    const isAR = workflowType === 'post_billing';
    const listLength = Array.isArray(data) ? data.length : 0;

    // 1. Define "Empty / New" defaults based on workflow type
    if (actionType === 'new') {
        return {
            field_group_ids: [],
            role_ids: [],
            process_name: isAR ? "AR" : "",
            id: "",
            sequence_num: listLength + 1,
            stage:isAR ? 'ar_denial_management' : "pre_billing",
            isEditing: true, // Pre-billing defaults to true; Post-billing (AR) defaults to false
            isNew: true
        };
    }

    // 2. Process existing items safely for edit/view mode
    return {
        id: item?.id ?? "",
        process_name: item?.process_name ?? (isAR ? "AR" : ""),
        sequence_num: item?.sequence_num ?? 0,
        field_group_ids: Array.isArray(item?.field_groups)
            ? item.field_groups.map(g => g?.id).filter(Boolean)
            : [],
        role_ids: Array.isArray(item?.roles)
            ? item.roles.map(r => r?.id).filter(Boolean)
            : [],
        stage:item.stage ?? "",
        isEditing: false,
        isNew: false
    };
};

export const checkForValidations = (data) => {
  // 1. Initialize a clean error state
  const result = {
    has_error: false,
    error_message: "",
    errors: {} // Changed to an object for easier key-value access
  };

  // 2. Define validation rules (Field : Error Translation Key)
  const rules = [
    { 
      field: 'process_name', 
      isValid: (val) => !!val, // Valid if it exists/is truthy
      msg: "work_flow.mandatory_field_error.process_name" 
    },
    { 
      field: 'field_group_ids', 
      isValid: (val) => Array.isArray(val) && val.length > 0, 
      msg: "work_flow.mandatory_field_error.field_group" 
    },
    { 
      field: 'role_ids', 
      isValid: (val) => Array.isArray(val) && val.length > 0, 
      msg: "work_flow.mandatory_field_error.roles" 
    }
  ];

  // 3. Execute validations
  for (const rule of rules) {
    const value = data[rule.field];
    
    if (!rule.isValid(value)) {
      result.has_error = true;
      result.error_message = i18n.t(rule.msg);
      result.errors[`${rule.field}_error`] = true;
      
      // Stop at the first error found (matching your original logic)
      break; 
    }
  }

  return result;
};



export const EscalationSettingsChange = (data, duplicate) => {
  const result = {};

  for (const key in data) {
    if (Object.hasOwn(data, key)) {
      if (JSON.stringify(data[key]) !== JSON.stringify(duplicate[key])) {
        result[key] = data[key];
      }
    }
  }

  return result;
};